const INITIAL_STATE = {};

export default function reducers(state = INITIAL_STATE, action) {
  switch (action.type) {
    default:
      return state;
  }
}
